import React, { useEffect, useState } from "react";
import PageTitle from "../../PageTitle";
import LeaveNavigation from "./navigation/LeaveNavigation";
import useAxios from "../../../utilities/useAxios";
import { getCurrentUserProfile } from "../../../utilities/AuthService";
import {
	Form,
	Input,
	DatePicker,
	Select,
	Button,
	message,
	Card,
	ConfigProvider,
	Statistic,
	Layout,
	Alert,
} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/lib/locale/ko_KR";
import useIsMobile from "../../../hooks/useIsMobile";
import PageHeader from "../../common/PageHeader";

dayjs.locale("ko");

const { Option } = Select;
const { Content } = Layout;

const ApplyForMenstrualLeave = () => {
	const isMobile = useIsMobile();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [userProfile, setUserProfile] = useState(null);
	const [leaveBalance, setLeaveBalance] = useState(null);

	useEffect(() => {
		message.config({ top: 150 });
		return () => message.config({ top: 8 });
	}, []);

	const fetchLeaveBalance = async () => {
		try {
			const response = await useAxios.get(
				"/utils/leave/balance/",
			);
			if (response.status === 200) {
				setLeaveBalance(response.data);
			}
		} catch (e) {
			console.error(e);
		}
	};

	useEffect(() => {
		(async () => {
			try {
				const profile = await getCurrentUserProfile();
				setUserProfile(profile);
				form.setFieldsValue({
					name: profile.name,
					position:
						profile.classification_name ===
						"교역자"
							? "교역자"
							: "교직원",
					application_date: dayjs(),
					leave_type: "생휴",
				});
			} catch (e) {
				message.error(
					"사용자 정보를 불러오는데 실패했습니다.",
				);
			}
			fetchLeaveBalance();
		})();
	}, [form]);

	const onFinish = async (values) => {
		setLoading(true);
		try {
			const response = await useAxios.post(
				"/utils/leave/apply/",
				{
					leave_type: "생휴",
					leave_date: values.leave_date.format(
						"YYYY-MM-DD",
					),
				},
			);
			if (response.status === 201) {
				message.success(
					"생리휴가 신청이 완료되었습니다.",
				);
				form.resetFields(["leave_date"]);
				if (userProfile) {
					form.setFieldsValue({
						name: userProfile.name,
						position:
							userProfile.classification_name ===
							"교역자"
								? "교역자"
								: "교직원",
						application_date: dayjs(),
						leave_type: "생휴",
					});
				}
				fetchLeaveBalance();
			}
		} catch (error) {
			message.error(
				error.response?.data?.error ||
					"신청 처리 중 오류가 발생했습니다.",
			);
		} finally {
			setLoading(false);
		}
	};

	const disabledDate = (current) => current && current.day() === 0;

	return (
		<ConfigProvider locale={locale}>
			<PageTitle title="생리휴가 신청" />
			<Layout className="member-layout">
				<LeaveNavigation />
				<Layout className="member-content-layout">
					<Content className="member-content">
						<div className="member-content__inner">
							<div className="member-content__form-container page">
								<PageHeader title="생리휴가 신청" />
								<Card className="surface-card">
									<Alert
										type="info"
										showIcon
										style={{
											marginBottom: 16,
											fontWeight: 600,
										}}
										message="여성 교직원은 월 1일의 무급 생리휴가를 신청할 수 있습니다."
									/>
									{leaveBalance && (
										<div
											style={{
												marginBottom: 16,
											}}>
											<Statistic
												title="이번 달 남은 생리휴가"
												value={
													leaveBalance.monthly_menstrual_leave_balance
												}
												suffix="회"
											/>
										</div>
									)}
									<Form
										form={
											form
										}
										layout="vertical"
										onFinish={
											onFinish
										}>
										<Form.Item
											name="name"
											label="이름">
											<Input
												disabled
											/>
										</Form.Item>
										<Form.Item
											name="position"
											label="직분">
											<Select
												disabled>
												<Option value="교역자">
													교역자
												</Option>
												<Option value="교직원">
													교직원
												</Option>
											</Select>
										</Form.Item>
										<Form.Item
											name="application_date"
											label="신청일">
											<DatePicker
												inputReadOnly={isMobile}
												style={{
													width: "100%",
												}}
												disabled
												format="YYYY-MM-DD"
											/>
										</Form.Item>
										<Form.Item
											name="leave_date"
											label="사용일"
											rules={[
												{
													required: true,
													message: "사용일을 선택해주세요",
												},
											]}>
											<DatePicker
												inputReadOnly={isMobile}
												style={{
													width: "100%",
												}}
												disabledDate={
													disabledDate
												}
												format="YYYY-MM-DD"
											/>
										</Form.Item>
										<Form.Item>
											<Button
												type="primary"
												htmlType="submit"
												loading={
													loading
												}
												block>
												신청하기
											</Button>
										</Form.Item>
									</Form>
								</Card>
							</div>
						</div>
					</Content>
				</Layout>
			</Layout>
		</ConfigProvider>
	);
};

export default ApplyForMenstrualLeave;
